





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { OnValidatedCallback } from '../../types/constants';

@Component
export default class InputField extends Vue {
  @Prop() name!: string;

  @Prop({ type: String, default: 'text' }) type!: string;

  @Prop() placeholder!: string;

  @Prop({ default: 'off' }) autocomplete!: string;

  @Prop({ type: String, default: '' }) value!: string;

  @Prop({ type: Function, default: () => true }) validationCallback!: () => boolean;

  @Prop({ type: Function, default: (): RegExp => /.*/g }) validationPattern!: () => RegExp;

  @Prop({ type: String }) errorText!: string;

  @Prop({ type: Number, default: 100 }) maxLength!: number;

  @Prop({ type: String, default: '320px' }) width!: string;

  @Prop({ type: Boolean, default: false }) focused!: boolean;

  $refs!: { input: HTMLElement };

  viewErrorMessage: string = this.errorText;

  isFocused: boolean = false;

  isInInitialState: boolean = true;

  isBouncing: boolean = false;

  isValid: boolean = false;

  created() {
    if (this.$parent) {
      this.$parent.$on(`validate:${this.name}`, (done: OnValidatedCallback) => done(this.validate()));
    }
  
    this.$on(`reset:${this.name}:styles`, () => {
      this.isInInitialState = true;
      this.isBouncing = false;
      this.isValid = false;
    });
  }

  updateValidity(validity: boolean): void {
    if (!validity) {
      this.bounceError();
    }

    this.isValid = validity;
  }

  updateValue(value: string) {
    this.$emit('update:value', value);
  }

  bounceError() {
    this.isBouncing = true;
    setTimeout(() => {
      this.isBouncing = false;
    }, 500);
  }

  async validate() {
    try {
      if (!this.isValidLength || !this.validationPattern().test(this.value)) {
        this.viewErrorMessage = this.errorText;
        this.updateValidity(false);

        return false;
      }

      const isValid = await this.validationCallback();
      this.updateValidity(isValid);
      this.viewErrorMessage = this.errorText;

      return isValid;
    } catch (e) {
      this.viewErrorMessage = (e as Error).message;
      this.updateValidity(false);

      return false;
    } finally {
      this.isInInitialState = false;
    }
  }

  get isInputEmpty(): boolean {
    return !this.value.trim();
  }

  get isValidLength(): boolean {
    return this.value.length <= this.maxLength;
  }

  onFocusHandler(): void {
    this.$emit('focus');
    this.isFocused = true;
  }

  onBlurHandler(): void {
    this.$emit('blur');
    this.isFocused = false;
    this.validate();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeHandler(ev: any) {
    this.updateValue(ev.target.value);
  }

  @Watch('focused')
  focusedChanged(isFocused: boolean) {
    if (isFocused) {
      this.$refs.input.focus();
      return;
    }
    this.$refs.input.blur();
  }
}
